import { render } from "./ComlineLogo.vue?vue&type=template&id=3ed80a37"
import script from "./ComlineLogo.vue?vue&type=script&lang=js"
export * from "./ComlineLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__